export { default as ContactDepartmentRouteService } from './ContactDepartmentRouteService';
export { default as ContactDepartmentService } from './ContactDepartmentService';